<template>
  <div>
    <v-layout row wrap class="px-5 mx-5">
      <v-flex xs3 text-xs-left px-4>
        <v-checkbox
          class="mt-2 mb-3"
          v-model="viewingBudget"
          label="Visualizar valores de orçamento"
          color="primary"
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex xs4 text-xs-left px-4>
        <v-checkbox
          class="mt-2 mb-3"
          v-model="viewingProections"
          label="Visualizar valores de projeção e realizados"
          color="primary"
          hide-details
        ></v-checkbox>
      </v-flex>
    </v-layout>
    <div id="wrapperComparativeReport" class="px-0">
      <div v-show="comparativeLines.length==0" class="pt-5">
        <h1
          class="headline font-weight-bold"
        >Selecione os campos acima e clique no botão para gerar o relatório</h1>
      </div>
      <v-data-table
        v-show="comparativeLines.length>0"
        :headers="comparativeHeader"
        :items="comparativeLines"
        hide-actions
        class="elevation-0 exccelTable"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['pa-0 stickyThCell',
               (header.text == 'Plano') ? 'firstStickyHeader text-xs-center' : 'text-xs-left',
                (header.text == 'Totais') ? 'secondStickyHeader tot' : ''
              ]"
            >
              <v-layout
                row
                justify-left
                pa-0
                grey--text
                text--darken-2
                :class="[(header.text != 'Plano') ? 'grey lighten-4' : '']"
              >
                <v-flex
                  xs12
                  pa-2
                  :class="[(header.text != 'Plano') ? 'bordLeft' : '', (header.text == 'Totais')? 'tagGridFirst' : '']"
                >
                  <span class="text-xs-left body-1">{{header.text}}</span>
                </v-flex>
              </v-layout>
              <v-layout
                :class="[(header.text == 'Totais')? 'tagGridFirst bordTop' : 'bordTop']"
                row
                justify-left
                pa-0
                grey--text
                text--darken-2
                v-if="header.text != 'Plano'"
              >
                <v-flex
                  xs4
                  text-xs-left
                  bordLeft
                  pa-2
                  v-show="((viewingBudget && !viewingProections) || (viewingBudget && viewingProections)) ? true : false"
                >
                  <span class="text-xs-left caption blue-grey--text text--darken-1">Orçado</span>
                </v-flex>
                <v-flex
                  xs4
                  text-xs-left
                  bordLeft
                  pa-2
                  v-show="((!viewingBudget && viewingProections) || (viewingBudget && viewingProections)) ? true : false"
                >
                  <span
                    class="text-xs-left caption blue-grey--text text--darken-1"
                  >Realizado / Projeção</span>
                </v-flex>
                <v-flex
                  v-show="viewingBudget && viewingProections"
                  xs4
                  caption
                  text-xs-center
                  blue-grey--text
                  text--darken-1
                  text-xs-left
                  bordLeft
                  pa-2
                >
                  <div class="text-xs-left">Diferença</div>
                </v-flex>
              </v-layout>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center pa-0 spreadsheetName caption fontfont-weight-bold stickyCell">
              <span>{{props.item.plan}}</span>
            </td>
            <td
              :class="['text-xs-center pa-0 spreadsheetValues caption fontfont-weight-bold stickyCell tot',!(viewingBudget && viewingProections) ? 'singleData':'']"
            >
              <v-layout row justify-left pa-0 mt-1 grey--text text--darken-2 v-show="inLine">
                <v-flex xs12>
                  <span
                    class="text-xs-left body-1 font-weight-bold pa-2"
                    v-show="(viewingBudget && !viewingProections)"
                  >
                    <!-- <b class="text-xs-left body-1 blue--text text--darken-5">Orçado:</b> -->
                    R$ {{sums(props.item, 'budget')}}
                  </span>
                  <span
                    class="text-xs-left body-1 font-weight-bold pa-2"
                    v-show="(!viewingBudget && viewingProections)"
                  >
                    <!-- <b class="text-xs-left body-1 deep-orange--text text--darken-1">Projeção:</b> -->
                    R$ {{sums(props.item, 'projction')}}
                  </span>
                </v-flex>
              </v-layout>
              <v-layout row justify-left pa-0 grey--text text--darken-2 v-show="!inLine">
                <v-flex xs4>
                  <!-- <span class="text-xs-left caption blue--text text--darken-5">Orçado</span> -->
                  <span
                    class="text-xs-left caption font-weight-bold pa-2"
                  >R$ {{sums(props.item, 'budget')}}</span>
                </v-flex>
                <v-flex xs4>
                  <!-- <span class="text-xs-left caption deep-orange--text text--darken-1">Projeção</span> -->
                  <span
                    class="text-xs-left caption font-weight-bold pa-2 bordLeft"
                  >R$ {{sums(props.item, 'projction')}}</span>
                </v-flex>
                <v-flex
                  xs4
                  caption
                  text-xs-left
                  blue-grey--text
                  text--darken-1
                  pa-2
                  bordLeft
                  negativeMarginGrd
                >
                  <!-- <div :style="{color: sums(props.item, 'color')}">Diferença</div> -->
                  <b :style="{color: sums(props.item, 'color')}">R$ {{sums(props.item, 'dif')}}</b>
                  <!-- <div :class="[setColor(item)]">Diferença</div>
                  <b :class="[setColor(item)]">{{setDif(item)}}</b>-->
                </v-flex>
              </v-layout>
              <!-- <v-layout v-show="showDifs" row justify-left px-2 pt-1 blue-grey lighten-4>
                <v-flex xs12 caption text-xs-left blue-grey--text text--darken-1>
                  <div :style="{color: sums(props.item, 'color')}">Diferença</div>
                  <b :style="{color: sums(props.item, 'color')}">R$ {{sums(props.item, 'dif')}}</b>
                </v-flex>
              </v-layout>-->
            </td>
            <td
              :class="['text-xs-left pa-0 spreadsheetValues posRelative', !(viewingBudget && viewingProections) ? 'singleData':'']"
              v-for="(item, i) in props.item.months"
              :key="i"
              @mouseover="item.hover = true"
              @mouseout="item.hover = false"
            >
              <div
                v-if="!item.realized && !inLine"
                class="pa-1 text-xs-left layout trControls exccel"
                v-show="item.hover"
              >
                <v-icon
                  small
                  class="deep-orange--text text--darken-1"
                  @click="openProjectionForm(i, props.item)"
                >edit</v-icon>
              </div>
              <v-layout row justify-left pa-0 mt-1 grey--text text--darken-2 v-show="inLine">
                <v-flex xs12>
                  <span
                    class="text-xs-left body-1 font-weight-bold pa-2"
                    v-show="(viewingBudget && !viewingProections)"
                  >
                    <!-- <b class="text-xs-left body-1 blue--text text--darken-5">Orçado:</b> -->
                    R$ {{formatPrice(item.budget)}}
                  </span>
                  <div v-show="(!viewingBudget && viewingProections)">
                    <v-flex xs12 v-if="!item.realized">
                      <!-- <span class="text-xs-left caption deep-orange--text text--darken-1">Projeção</span> -->
                      <span class="text-xs-left body-1 font-weight-bold pa-2">
                        <!-- <b class="text-xs-left body-1 deep-orange--text text--darken-1">Projeção:</b> -->
                        R$ {{formatPrice(item.projection)}}
                      </span>
                    </v-flex>
                    <v-flex xs12 v-if="item.realized">
                      <!-- <span class="text-xs-left caption teal--text text--darken-1">Realizado</span> -->
                      <span class="text-xs-left body-1 font-weight-bold pa-2">
                        <!-- <b class="text-xs-left body-1 teal--text text--darken-1">Realizado:</b> -->
                        R$ {{formatPrice(item.realized)}}
                      </span>
                    </v-flex>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row justify-left pa-0 grey--text text--darken-2 v-show="!inLine">
                <v-flex xs4>
                  <!-- <span class="text-xs-left caption blue--text text--darken-5">Orçado</span> -->
                  <span
                    class="text-xs-left caption font-weight-bold pa-2"
                  >R$ {{formatPrice(item.budget)}}</span>
                </v-flex>
                <v-flex xs4 v-if="!item.realized">
                  <!-- <span class="text-xs-left caption deep-orange--text text--darken-1">Projeção</span> -->
                  <span
                    class="text-xs-left caption font-weight-bold pa-2 bordLeft"
                  >R$ {{formatPrice(item.projection)}}</span>
                </v-flex>
                <v-flex xs4 v-if="item.realized">
                  <!-- <span class="text-xs-left caption teal--text text--darken-1">Realizado</span> -->
                  <span
                    class="text-xs-left caption font-weight-bold pa-2 bordLeft"
                  >R$ {{formatPrice(item.realized)}}</span>
                </v-flex>
                <v-flex xs4 caption text-xs-left pa-2 bordLeft negativeMarginGrd>
                  <!-- <div :class="[setColor(item)]">Diferença</div> -->
                  <b :class="[setColor(item)]">{{setDif(item)}}</b>
                </v-flex>
              </v-layout>

              <!-- <v-layout v-show="showDifs" row justify-left px-2 pt-1 blue-grey lighten-5>
                <v-flex xs12 caption text-xs-left>
                  <div :class="[setColor(item)]">Diferença</div>
                  <b :class="[setColor(item)]">{{setDif(item)}}</b>
                </v-flex>
              </v-layout>-->
            </td>
          </tr>
        </template>
      </v-data-table>
      <ProjectionEditForm
        :generate="generate"
        :projectionFormShow="projectionFormShow"
        :closeProjectionForm="closeProjectionForm"
        :projectionFormValue="projectionFormValue"
      />
    </div>
  </div>
</template>

<script>
import ProjectionEditForm from './ProjectionEditForm'

export default {
  name: 'GridComparativeBudgetRealized',

  props: {
    generate: Function,
    comparativeLines: Array
  },

  components: {
    ProjectionEditForm
  },

  data () {
    return {
      inLine: false,
      showDifs: true,
      viewingProections: true,
      viewingBudget: true,
      projectionFormValue: {},
      projectionFormShow: false,
      comparativeHeader: []
    // comparativeLines: []
    }
  },

  beforeMount () {
    // this.buildHeader();
  },

  mounted () {
    // this.getResponseDate();
    this.setGridHeight()
  },

  watch: {
    comparativeLines (v) {
      if (v.length > 0) {
        this.buildHeader()
      }
    },

    viewingProections (v) {
      if (!v && !this.viewingBudget) {
        setTimeout(() => {
          this.viewingProections = true
        }, 10)
      }
      this.setViewReportType()
    },

    viewingBudget (v) {
      if (!this.viewingProections && !v) {
        setTimeout(() => {
          this.viewingBudget = true
        }, 10)
      }
      this.setViewReportType()
    }
  },

  methods: {
    setViewReportType () {
      let showDifs = 0
      let inLine = 0
      if (this.viewingBudget) {
        showDifs++
        inLine++
      }
      if (this.viewingProections) {
        showDifs++
        inLine++
      }
      this.inLine = inLine < 2
      this.showDifs = showDifs > 1
    },

    totSetColor (budget, projection, data) {
      let percentDif = (budget / projection - 1) * 100
      /*
      negative_color: "#00BC2A"
      negative_percentage: "44"
      positive_color: "#00BC2A"
      positive_percentage: "22"
      */
      // console.log('pctg', percentDif)
      if (percentDif > 0) {
        if (percentDif >= data.positive_percentage) {
          return data.positive_color
        }
        return ''
      } else {
        if (percentDif <= data.negative_percentage) {
          return data.negative_color
        }
        return ''
      }
      // return color;
      // console.log(parseInt(percentDif));
    },

    sums (data, type) {
      let budgetSum = 0
      let projectionSum = 0
      let dif = 0
      for (let i = 0; i < data.months.length; i++) {
        let prjVal = data.months[i].realized
          ? data.months[i].realized
          : data.months[i].projection
        budgetSum = budgetSum + parseFloat(data.months[i].budget)
        projectionSum = projectionSum + parseFloat(prjVal)
      }
      dif = budgetSum - projectionSum
      // console.log(this.formatPrice(budgetSum));
      if (type === 'budget') {
        return this.formatPrice(budgetSum)
      }
      if (type === 'projction') {
        return this.formatPrice(projectionSum)
      }
      if (type === 'dif') {
        return this.formatPrice(dif)
      }
      if (type === 'color') {
        let percentDif = (budgetSum / projectionSum - 1) * 100
        if (percentDif > 0) {
          if (percentDif >= data.positive_percentage) {
            return data.positive_color
          }
          return ''
        } else {
          if (percentDif <= data.negative_percentage) {
            return data.negative_color
          }
          return ''
        }
      }
    },

    closeProjectionForm () {
      this.projectionFormShow = false
    },

    openProjectionForm (ind, data) {
      console.log('projection', ind, data)
      // this.projectionFormValue.initMonth = `${year}-${
      //   ind + 1 <= 9 ? "0" : ""
      // }${ind + 1}`;
      this.projectionFormValue.initMonth = data.months[ind].date
      this.projectionFormValue.endMonth = data.months[ind].date
      // this.projectionFormValue.endMonth = `${year}-${
      //   ind + 1 <= 9 ? "0" : ""
      // }${ind + 1}`;
      this.projectionFormValue.provided_id = data.months[ind].provided_id
      this.projectionFormShow = true
    },

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    setColor (data) {
      let val = 0
      let divider
      let cssClass
      if (!data.realized) {
        divider = data.budget < data.projection ? data.budget : data.projection
        val = ((data.budget - data.projection) / divider) * 100
        if (val !== 0) {
          cssClass =
            val > 0 ? 'green--text text--darken-3' : 'red--text text--darken-4'
          return cssClass
        }
        return 'blue-grey--text text--darken-1'
      }

      divider = data.budget < data.realized ? data.budget : data.realized
      val = ((data.budget - data.realized) / divider) * 100
      cssClass =
        val >= 0 ? 'green--text text--darken-3' : 'red--text text--darken-4'
      return cssClass
    },

    setDif (data) {
      let val = '-'
      let divider
      if (!data.realized) {
        // divider = data.budget < data.projection ? data.budget : data.projection;
        if (data.budget - data.projection !== 0) {
          val = val = `R$ ${this.formatPrice(data.budget - data.projection)}`
        }
        return val
      }
      divider = data.budget < data.realized ? data.budget : data.realized
      // val = ((data.budget - data.realized) / divider) * 100;
      // return `${val.toFixed(2)} %`;
      val = `R$ ${this.formatPrice(data.budget - data.realized)}`
      return val
    },
    // getResponseDate() {
    //   let allLines = this.$store.state.responseTest.map(line => {
    //     line.months.map(month => {
    //       month.hover = false;
    //       return month;
    //     });
    //     return line;
    //   });
    //   this.comparativeLines = [...allLines];
    //   //console.log(this.comparativeLines);
    // },
    buildHeader () {
      this.comparativeHeader = []
      let arrayHeader = [
        // "Plano",
        // "Totais",
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ]

      let endArr = ['Plano', 'Totais']
      let ActualHeader = this.comparativeLines[0].months
      for (let i = 0; i < ActualHeader.length; i++) {
        let month = ActualHeader[i].date.split('-')[1] - 1
        endArr.push(arrayHeader[month])
      }

      endArr.map(item => {
        let headerItem = {
          class: 'px-2 font-weight-bold body-1 stickyThCell',
          align: 'center',
          sortable: false
        }
        headerItem.text = item
        if (item === 'Plano') {
          headerItem.class =
            'px-2 font-weight-bold body-1 stickyCell firstStickyHeader'
        }
        if (item === 'Totais') {
          headerItem.class =
            'px-2 font-weight-bold body-1 stickyCell secondStickyHeader tot'
        }

        // console.log('header')
        this.comparativeHeader.push(headerItem)
      })
    },

    setGridHeight () {
      let grid = document.querySelector(
        '#wrapperComparativeReport .v-table__overflow'
      )
      let windowH = window.innerHeight
      grid.style.overflowY = 'auto'
      grid.style.maxHeight = `${windowH - 180}px`
      // grid.style.height = `${windowH - 215}px`;
    }
  }
}
</script>

<style>
.bg-f9f9f9 {
  background: #f9f9f9;
}
#wrapperComparativeReport {
  border-top: 1px solid #ccc;
}
#wrapperComparativeReport table.v-table {
  width: max-content;
  max-width: 200%;
  border-bottom: 1px solid #c5c5c5;
  margin-bottom: 1px;
}
#wrapperComparativeReport td.spreadsheetValues.tot {
  background: #eceff1;
  /*#cfd8dc*/
}
#wrapperComparativeReport td.spreadsheetValues {
  min-width: 380px;
  background: #fff;
  border-right: 1px solid #c5c5c5;
  border-left: 1px solid #c5c5c5;
}
#wrapperComparativeReport td.spreadsheetValues.singleData {
  min-width: 135px;
}
#wrapperComparativeReport td.spreadsheetName {
  max-width: 300px;
}
#wrapperComparativeReport tr:hover {
  background: #f9f9f9;
}
.spreadsheetValues span {
  display: block;
}
.borderTopWhite {
  border-top: 1px solid#eee !important;
}
.exccel {
  /* box-shadow: none !important; */
  /* background-color: transparent !important; */
  top: 3px !important;
  /* left: 2px !important; */
  right: 131px !important;
  border-radius: 50px;
}

.exccel i {
  font-size: 15px !important;
}

.miniFont {
  font-size: 11px;
  font-weight: 300;
}

.bordLeft {
  border-left: 1px solid #c5c5c5;
}

.bordTop {
  border-top: 1px solid #c5c5c5;
}

.tagGridFirst {
  background: #eceff1;
}
.stickyCell.tot {
  min-width: 380px;
  background: #e3f2fd;
  left: 284px;
}
.stickyCell.tot.singleData {
  min-width: 135px;
}

.stickyCell {
  position: sticky;
  min-width: 285px;
  z-index: 2;
  background: #fff;
  left: 0;
}
.stickyThCell.firstStickyHeader {
  padding: 0;
  top: 0;
  z-index: 3;
  left: 0;
}
.stickyThCell.secondStickyHeader {
  padding: 0;
  top: 0;
  left: 284px;
  z-index: 3;
  background: #fff;
}
.stickyThCell {
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
}

#wrapperComparativeReport table.v-table tbody td {
  height: auto;
}

.negativeMarginGrd {
  margin-left: -1px;
}
</style>
